import { useContext } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Redirect, useHistory } from 'react-router-dom';
import { Formik, Form } from 'formik';
import ValidationInput from '../components/ValidationTextInput';
import TitleCard from '../components/TitleCard';
import Logo from '../components/Logo';
import * as Yup from 'yup';
import { useAPI } from '../services/api';
import AuthContext from '../store/auth-context';
import ToastContext from '../store/toast-context';
import '../styles/pages/Login.scss';
import '../styles/components/custom-buttons.scss';

const stringValidation = ({ min = 2, max = 255 } = {}) =>
  Yup.string().min(min, 'Too Short!').max(max, 'Too Long!').required('Required');

const loginSchema = Yup.object().shape({
  username: stringValidation(),
  password: stringValidation(),
});

const LoginPage = () => {
  let api = useAPI();
  const history = useHistory();
  const auth = useContext(AuthContext);
  const { handleError, success } = useContext(ToastContext);
  let redirectPath = new URLSearchParams(history.location.search).get('redirect') ?? '/';

  const login = async (values) => {
    values.username = values.username.trim();
    try {
      await api.post('/users/login', values);
      let response = await api.post('/users/accessToken');
      auth.login(response.headers['x-access-token'], response.data.exp);
      history.replace(redirectPath);
      success('Logged in!');
    } catch (e) {
      handleError(e);
    }
  };

  const initialValues = {
    username: '',
    password: '',
  };

  if (auth.isLoggedIn) {
    return <Redirect to="/home" />;
  }

  const register = () => {
    history.push('/register');
  };

  const forgotPassword = () => {
    history.push('/forgot-password');
  };

  return (
    <>
      <Logo />
      <Row>
        <Col xs={12} sm={8} lg={5} className="mx-auto">
          <TitleCard title="Mortgage Tax Payment" subTitle="For Mortgage Companies Only">
            <Formik onSubmit={login} initialValues={initialValues} validationSchema={loginSchema}>
              <Form className="py-3 px-4 mt-2 text-start">
                <ValidationInput
                  aria-label="username-input"
                  name="username"
                  label=""
                  placeholder="Username"
                  autoComplete="username"
                />
                <ValidationInput
                  aria-label="password-input"
                  name="password"
                  label=""
                  placeholder="Password"
                  password
                  autoComplete="current-password"
                />
                <Row className="text-center">
                  <Col>
                    <Button type="submit" size="md" className="p-2 my-2 w-100 dark-btn">
                      Login
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Formik>
          </TitleCard>
        </Col>
      </Row>
      <Row className="forgot-register p-2 mt-3 mb-5 mx-auto">
        <Col className="p-0">
          <Row className="py-1 mx-auto text-center">
            <Col>
              Forgot password?
              <a className="mx-2" href="" onClick={forgotPassword}>
                Reset it.
              </a>
            </Col>
          </Row>
          <Row className="py-1 mx-auto text-center">
            <Col>
              New user?
              <a className="mx-2" href="" onClick={register}>
                Create an account.
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default LoginPage;
